import EntityService from '@/services/EntityService'
import { Vendor } from '@/models/vendor'
import BillService from '@/services/BillService'
import FirebaseService from '@/services//FirebaseService'
import { collectionGroup, getDocs, query, where } from 'firebase/firestore'
import { PurchaseOrder, purchaseOrderConverter } from '@/models/purchaseOrder'

export default class VendorService extends EntityService<Vendor> {
  constructor() {
    super({ collectionName: 'vendors' })
  }

  async getPurchaseOrders(vendorId: string) {
    const db = await FirebaseService.firestore()
    const collectionRef = collectionGroup(db, 'purchaseOrders')
    const querySnapshot = query(collectionRef, where('vendorId', '==', vendorId)).withConverter(purchaseOrderConverter)

    return (await getDocs(querySnapshot)).docs.map(doc => doc.data()) as PurchaseOrder[]
  }

  async getBills(vendorId: string) {
    const billService = new BillService()
    return billService.find_by('payee', '==', vendorId)
  }
}